import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { map, take, tap, startWith } from 'rxjs/operators';
import { Observable } from 'rxjs';
import Swal from 'sweetalert2';
import { EncrDecrServiceService } from 'src/app/services/encr-decr-service.service';
import { Title } from '@angular/platform-browser';
import { EmployeeProfile } from '../model/useraccessdata';
import { LoginService } from '../services/login.service';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

declare let $: any;

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent implements OnInit {
    title = 'User Profile';
    panelOpenState = false;
    ProfileForm: FormGroup;
    useridmain: any;
    public DisplayNone: boolean = true;
    public DisplayEmpNone: boolean = true;
    LandingValues: LandingAppType[] = [
        { value: '1', viewValue: 'MANAGEMENT DASHBOARD' },
        { value: '2', viewValue: 'LINER AGENCY' },
        { value: '3', viewValue: 'FREIGHT FORWARDING' },
        { value: '4', viewValue: 'FINANCE' },
        { value: '5', viewValue: 'SYSTEM ADMIN' },
    ];
    constructor(private matIconRegistry: MatIconRegistry, private titleService: Title, private router: Router, private LService: LoginService,
        private domSanitizer: DomSanitizer, private route: ActivatedRoute, private ES: EncrDecrServiceService, private fb: FormBuilder,) {
        this.matIconRegistry.addSvgIcon(
            "freight",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/freight.svg")
        );
        this.matIconRegistry.addSvgIcon(
            "profit",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/profit.svg")
        );
        this.matIconRegistry.addSvgIcon(
            "user",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/user.svg")
        );
        this.matIconRegistry.addSvgIcon(
            "database",
            this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/database.svg")
        );
    }

    ngOnInit(): void {
        this.createForm();
        this.titleService.setTitle(this.title);
        $(function () {
            $('.integerInput').on('input', function () {
                this.value = this.value
                    .replace(/[^\d]/g, '');// numbers and decimals only

            });
        });

        $('.my-select').select2();
        $(document).on('select2:open', (e) => {
            const selecNID = e.target.id

            $(".select2-search__field[aria-controls='select2-" + selecNID + "-results']").each(function (
                key,
                value,
            ) {
                value.focus();
            })
        });
        $(document).on('focus', '.select2-selection.select2-selection--single', function (e) {
            $(this).closest(".select2-container").siblings('select:enabled').select2('open');
        });
        //$("#ddlLandingApp").val().trigger("change");
        if (localStorage.getItem("UserType") == "132" || localStorage.getItem("UserType") == "133") {
            this.DisplayNone = true;
        }
        else {
            this.DisplayNone = false;
        }
        if (localStorage.getItem("UserType") == "134") {
            this.DisplayEmpNone = true;
        }
        else {
            this.DisplayEmpNone = false;
        }
    }
    createForm() {
        this.ProfileForm = this.fb.group({
            ID: 0,
            UserID: 0,
            UserType: 0,
            User_Idv: '',
            Reset_Password:'',
            User_Active: '',
            Employee_Code: '',
            Landing_Application_Id: 0,
            EmployeeName: '',
            ShortName: '',
            Employee_Active_Status: '',
            Gender: '',
            DOB: '',
            Designation: '',
            Landline: '',
            Mobile: '',
            Email: '',
            DateOfJoining: '',
            DateOfConfirmation: '',
            DateOfRelieving: '',
            Division_Name: '',
            Office_Name: '',
            Department: '',
            Reporting_to: '',
            HOD: '',
            SBU_Division_Head:''
        });
    }
    modal() {
        
        this.ProfileForm.value.UserId = localStorage.getItem("UserId");
        this.ProfileForm.value.UserType = localStorage.getItem("UserType");
        this.LService.GetEmployeeProfile(this.ProfileForm.value).subscribe(data => {
            $("#txtuserid").val(data[0].Email);
            $("#txtEmail").val(data[0].Email);
            $("#txtResetPassword").val(data[0].Reset_Password);
            $("#txtEmpCode").val(data[0].Employee_Code);
            $("#txtuseractive").val(data[0].User_Active);
            $("#txtGender").val(data[0].Gender);
            $("#txtEmpActive").val(data[0].Employee_Active_Status)
            $("#txtEmpName").val(data[0].EmployeeName);
            $("#txtShortName").val(data[0].ShortName);
            $("#txtDOB").val(data[0].DOB);
            $("#txtDesignation").val(data[0].Designation);
            $("#txtLandline").val(data[0].Landline);
            $("#txtMobile").val(data[0].Mobile);
            $("#txtDOJ").val(data[0].DateOfJoining);
            $("#txtDOC").val(data[0].DateOfConfirmation);
            $("#txtDOR").val(data[0].DateOfRelieving);
            $("#ddlDivision").val(data[0].Division_Name);
            $("#ddlOffice").val(data[0].Office_Name);
            $("#txtDepartment").val(data[0].Department);
            $("#txtReportingTo").val(data[0].ReportingTo);
            $("#txtHOD").val(data[0].HOD);
            $("#txtSBUHead").val(data[0].SBU_Division_Head);
            $("#ddlLandingApp").select2().val(data[0].Landing_Application_Id).trigger("change");
            $("#txtVendorName").val(data[0].VendorName);
            $("#txtVendorBranch").val(data[0].VendorBranch);
        });
        $('#UserProfile').modal('show');
    }
    OnSubmit() {
        this.ProfileForm.value.UserId = localStorage.getItem("UserId");
        this.ProfileForm.value.UserType = localStorage.getItem("UserType");
        if ($("#ddlLandingApp").val() != 0) {
            this.ProfileForm.value.Landing_Application_Id = $("#ddlLandingApp").val();
        }
        else {
            this.ProfileForm.value.Landing_Application_Id = 0;
        }
        this.ProfileForm.value.Landing_Application = $("#ddlLandingApp option:selected").text();
        this.LService.UpdateEmployeeProfile(this.ProfileForm.value).subscribe(data => {
            Swal.fire("Updated Successfully");
        });
    }

    OnResetPassword() {

        $('#PasswordRestModal').modal('show');
        //this.disablegenerate = false;
    }
}
interface LandingAppType {
    value: string;
    viewValue: string;
}